(function () {
  'use strict';

  var byju = (window.byju = window.byju || {});
  var config = byju;
  var routes = config.routes || {};
  var strings = config.strings || {};
  var SECTION = 'cart-drawer';
  var queue = Promise.resolve();

  function getDrawer() {
    return document.getElementById('CartDrawer');
  }

  function toast(message) {
    if (byju.toast) byju.toast(message);
  }

  function parseSection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-cart-inner]');
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.setAttribute('data-count', String(count));
    });
  }

  function renderDrawer(sections) {
    var html = sections && sections[SECTION];
    var current = document.querySelector('#CartDrawer [data-cart-inner]');
    if (!html || !current) return null;
    var next = parseSection(html);
    if (!next) return null;

    Array.prototype.forEach.call(current.querySelectorAll('details[id]'), function (details) {
      var fresh = next.querySelector('details[id="' + details.id + '"]');
      if (fresh) fresh.open = details.open;
    });
    current.replaceWith(next);
    updateCount(parseInt(next.getAttribute('data-item-count'), 10) || 0);
    return next;
  }

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var error = new Error(data.description || data.message || strings.error);
          error.data = data;
          throw error;
        }
        return data;
      });
    });
  }

  function sectionParams() {
    return { sections: SECTION, sections_url: window.location.pathname };
  }

  function refreshDrawer() {
    return fetch(routes.root + '?sections=' + SECTION)
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        renderDrawer(sections);
      })
      .catch(function () {});
  }

  function showDrawerError(message) {
    var box = document.querySelector('#CartDrawer [data-cart-error]');
    if (!box) {
      toast(message);
      return;
    }
    box.textContent = message;
    box.hidden = false;
  }

  function setBusy(button, busy) {
    if (!button) return;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  }

  function showFormError(form, message) {
    var box = form.querySelector('[data-form-error]');
    if (box) {
      box.textContent = message;
      box.hidden = false;
    } else {
      toast(message);
    }
  }

  function clearFormError(form) {
    var box = form.querySelector('[data-form-error]');
    if (box) {
      box.textContent = '';
      box.hidden = true;
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-cart-form')) return;
    if (event.defaultPrevented) return;

    event.preventDefault();
    var submitter = event.submitter && event.submitter.hasAttribute('data-add-button') ? event.submitter : null;
    var button = submitter || form.querySelector('[data-add-button]');
    if (button && button.getAttribute('aria-busy') === 'true') return;
    var buyNow = !!(submitter && submitter.hasAttribute('data-buy-now'));
    var giftWrap = form.querySelector('[data-gift-wrap]');
    var giftWrapId = giftWrap && giftWrap.checked ? giftWrap.getAttribute('data-gift-wrap') : null;
    var imageFee = form.querySelector('[data-image-fee]:checked');
    var phraseFee = form.querySelector('[data-phrase-fee]:checked');

    clearFormError(form);
    setBusy(button, true);

    var extras = [];
    var formData = new FormData(form);
    var qty = parseInt(formData.get('quantity'), 10) || 1;
    if (imageFee) {
      extras.push({
        id: Number(imageFee.getAttribute('data-image-fee')),
        quantity: qty,
        properties: {
          '_Peça': imageFee.getAttribute('data-image-fee-title') || '',
          _gravacao_id: formData.get('properties[_gravacao_id]') || ''
        },
      });
    }
    if (phraseFee) {
      extras.push({
        id: Number(phraseFee.getAttribute('data-phrase-fee')),
        quantity: qty,
        properties: {
          '_Peça': phraseFee.getAttribute('data-phrase-fee-title') || '',
          _frase_id: formData.get('properties[_frase_id]') || ''
        },
      });
    }
    if (giftWrapId) extras.push({ id: Number(giftWrapId), quantity: 1 });

    var body = new FormData(form);
    if (!extras.length) {
      body.append('sections', SECTION);
      body.append('sections_url', window.location.pathname);
    }

    postAdd(body)
      .then(function (data) {
        if (!extras.length) return data;
        return postAdd(
          JSON.stringify({ items: extras, sections: SECTION, sections_url: window.location.pathname }),
          true
        );
      })
      .then(function (data) {
        if (buyNow) {
          window.location.href = (routes.root || '/') + 'checkout';
          return;
        }
        if (document.querySelector('[data-cart-page]')) {
          window.location.reload();
          return;
        }
        var rendered = renderDrawer(data.sections);
        if (!rendered) {
          refreshDrawer();
        }
        var drawerEl = getDrawer();
        if (config.cartType === 'drawer' && config.openCartOnAdd !== false && drawerEl && byju.drawer) {
          byju.drawer.open(drawerEl, button || document.activeElement);
        } else {
          toast(strings.added);
        }
        form.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));
      })
      .catch(function (error) {
        buyNow = false;
        showFormError(form, error.message || strings.error);
      })
      .finally(function () {
        if (!buyNow) setBusy(button, false);
      });
  });

  function postAdd(body, isJson) {
    var headers = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' };
    if (isJson) headers['Content-Type'] = 'application/json';
    return fetch(routes.cartAdd, { method: 'POST', headers: headers, body: body }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || strings.error);
        }
        return data;
      });
    });
  }

  function changeLine(line, quantity, focusSelector) {
    queue = queue.then(function () {
      var inner = document.querySelector('#CartDrawer [data-cart-inner]');
      if (inner) inner.classList.add('is-updating');
      var params = sectionParams();
      var row = document.querySelector('#CartDrawer [data-cart-item][data-line="' + line + '"]');
      var feeKeys = row && row.getAttribute('data-fee-keys');
      var request = { line: line, quantity: quantity };
      var url = routes.cartChange;

      if (feeKeys) {
        var updates = {};
        updates[row.getAttribute('data-key')] = quantity;
        feeKeys.split(' ').forEach(function (key) { updates[key] = quantity; });
        request = { updates: updates };
        url = routes.cartUpdate;
      }
      request.sections = params.sections;
      request.sections_url = params.sections_url;
      return requestJson(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(request)
      })
        .then(function (cart) {
          renderDrawer(cart.sections);
          var drawerEl = getDrawer();
          var target = focusSelector && drawerEl && drawerEl.querySelector(focusSelector);
          if (!target && drawerEl) target = drawerEl.querySelector('.drawer__title');
          if (!target) return;
          target.focus({ preventScroll: true });

          if (target instanceof HTMLInputElement) {
            try {
              var end = target.value.length;
              target.type = 'text';
              target.setSelectionRange(end, end);
              target.type = 'number';
            } catch (e) {}
          }
        })
        .catch(function (error) {
          return refreshDrawer().then(function () {
            showDrawerError(error.message || strings.error);
          });
        })
        .finally(function () {
          var current = document.querySelector('#CartDrawer [data-cart-inner]');
          if (current) current.classList.remove('is-updating');
        });
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('#CartDrawer input[data-line]')) return;
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);
    var line = parseInt(input.getAttribute('data-line'), 10);

    var active = document.activeElement;
    var wrap = input.closest('[data-quantity]');
    var focusSelector = 'input[data-line="' + line + '"]';
    if (active && wrap && wrap.contains(active) && active !== input) {
      var which = active.hasAttribute('data-qty-plus') ? '[data-qty-plus]' : '[data-qty-minus]';
      focusSelector = '[data-cart-item][data-line="' + line + '"] ' + which;
    } else if (active !== input) {
      focusSelector = null;
    }
    changeLine(line, quantity, focusSelector);
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-cart-page] .qty__input')) return;
    var form = input.form;
    if (!form) return;

    form.querySelectorAll('input[data-fee-for="' + input.getAttribute('data-line') + '"]').forEach(function (feeInput) {
      feeInput.value = input.value;
    });
    var submitter = form.querySelector('[name="update"]');
    if (form.requestSubmit) {
      form.requestSubmit(submitter);
    } else {
      form.submit();
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    var pageRemove = target.closest('[data-cart-page] [data-cart-remove]');
    if (pageRemove) {
      var pageRow = pageRemove.closest('[data-cart-item]');
      var pageFeeKeys = pageRow && pageRow.getAttribute('data-fee-keys');
      if (pageFeeKeys) {
        event.preventDefault();
        var pageUpdates = {};
        pageUpdates[pageRow.getAttribute('data-key')] = 0;
        pageFeeKeys.split(' ').forEach(function (key) { pageUpdates[key] = 0; });
        requestJson(routes.cartUpdate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: pageUpdates })
        }).then(function () { window.location.reload(); }, function () { window.location.href = pageRemove.href; });
        return;
      }
    }

    var remove = target.closest('#CartDrawer [data-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(parseInt(remove.getAttribute('data-line'), 10), 0);
      return;
    }

    var opener = target.closest('[data-cart-open]');
    if (opener && config.cartType === 'drawer' && getDrawer() && byju.drawer) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
      event.preventDefault();
      byju.drawer.open(getDrawer(), opener);
    }
  });

  var noteTimer = null;
  document.addEventListener('input', function (event) {
    var note = event.target;
    if (!(note instanceof HTMLTextAreaElement) || !note.hasAttribute('data-cart-note')) return;
    var counter = note.parentElement.querySelector('[data-note-counter]');
    if (counter) counter.textContent = note.value.length + '/' + (note.maxLength > 0 ? note.maxLength : 200);
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      fetch(routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(function () {});
    }, 500);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-discount-form')) return;

    var input = form.elements.namedItem('discount');
    var code = input ? input.value.trim() : '';
    if (!code) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    var button = event.submitter || Array.prototype.find.call(form.elements, function (el) {
      return el.type === 'submit';
    });
    setBusy(button, true);
    fetch((routes.root || '/') + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () {
        if (document.querySelector('[data-cart-page]')) {
          window.location.reload();
          return null;
        }
        return refreshDrawer();
      })
      .finally(function () {
        setBusy(button, false);
      });
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;

    Array.prototype.forEach.call(document.querySelectorAll('[aria-busy="true"]'), function (el) {
      if (el.matches('button, [data-add-button]')) setBusy(el, false);
      else el.removeAttribute('aria-busy');
    });
    Array.prototype.forEach.call(document.querySelectorAll('.is-updating'), function (el) {
      el.classList.remove('is-updating');
    });
    if (getDrawer()) refreshDrawer();
  });
})();
